import controller from './box-products-mini.controller';
import templateDefault from './templates/box-products-mini-default.view.html';

let BoxProductsMiniComponent = {
    template: templateDefault,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        itemId: '@',
        categoryId: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {

    let response = SessionService.get('components');
    if (response.boxProducts.component == 'templateT1') {
        return templateT1
    } else {
        return templateDefault;
    }
}

export default BoxProductsMiniComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/box-products-mini/box-products-mini.component.js
 **/